import { useEffect, useState } from "react";
import { ESessionKeys } from "../../@types";
export const useSessionHertzLink = () => {
    const [sessionHertzLink, setSessionHertzLink] = useState();
    const storage = window.sessionStorage;
    const setHertzLink = (val) => {
        storage.setItem(ESessionKeys.HertzLink, JSON.stringify(val));
        setSessionHertzLink(val);
    };
    const clearHertzLink = () => {
        storage.removeItem(ESessionKeys.HertzLink);
        setSessionHertzLink(undefined);
    };
    const getHertzLinkFromStorage = () => {
        return storage.getItem(ESessionKeys.HertzLink);
    };
    const getSessionHertzLink = () => {
        const sessionStorageHertzLink = getHertzLinkFromStorage();
        // return undefined if hertzlink is not found
        // instead of JSON parsing undefined
        if (sessionStorageHertzLink) {
            setSessionHertzLink(JSON.parse(sessionStorageHertzLink));
        }
        else {
            setSessionHertzLink(undefined);
        }
    };
    useEffect(() => {
        // get the hertzlink on mount
        getSessionHertzLink();
    }, []);
    return {
        sessionHertzLink,
        setHertzLink,
        clearHertzLink,
    };
};
